// Visual configuration for transaction rows: badge labels/colors used in the
// type cell, plus accent color (the colored bar on the left of each row).
// Keyed on display_type (or aggregate type).

export type TransactionBadge = { label: string; color: string }

export const transactionBadgeMap: Record<string, TransactionBadge> = {
  capital_call: { label: 'Capital Call', color: 'V_CAPITAL' },
  distribution: { label: 'Distribution', color: 'V_DISTRIBUTION_RETURN_OF_CAPITAL' },
  cash_distribution: { label: 'Cash Distribution', color: 'V_DISTRIBUTION_RETURN_OF_CAPITAL' },
  asset_funds: { label: 'Asset funds', color: 'V_DISTRIBUTION_RETURN_OF_CAPITAL' },
  recycled_funds: { label: 'Recycled Funds', color: 'V_CAPITAL' },
  loss_investment: { label: 'Realized Loss', color: 'V_DISTRIBUTION_RETURN_OF_CAPITAL' },
  portfolio_distribution: { label: 'Portfolio Distribution', color: 'V_DISTRIBUTION_RETURN_OF_CAPITAL' },
  other_fee: { label: 'Other Fee', color: 'V_OTHER_FEE' },
  management_fee: { label: 'Management Fee', color: 'V_MANAGEMENT_FEE' },
  operating_income: { label: 'Operating Income', color: 'V_CAPITAL' },
  operating_expense: { label: 'Operating Expense', color: 'V_OTHER_FEE' },
  syndication_fee: { label: 'Syndication Cost', color: 'V_OTHER_FEE' },
  interest_allocation_received: { label: 'Catch-up Interest Received', color: 'V_CAPITAL' },
  interest_allocation_paid: { label: 'Catch-up Interest Paid', color: 'V_CAPITAL' },
  scheduled_call: { label: 'Scheduled Call', color: 'V_CAPITAL' },
}

const ACCENT_FALLBACK = 'V_OTHER_FEE'

const accentColorMap: Record<string, string> = {
  capital_call: 'V_CAPITAL',
  scheduled_call: 'V_CAPITAL',
  cash_distribution: 'V_DISTRIBUTION_PROFIT',
  recycled_funds: 'V_CAPITAL',
  asset_funds: 'V_DISTRIBUTION_PROFIT',
}

export function accentColorFor(displayType: string | undefined | null): string {
  if (!displayType) return ACCENT_FALLBACK
  return accentColorMap[displayType] ?? ACCENT_FALLBACK
}
